import './new-salary-type.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateSalaryType } from "@core/query/salary-type.query";
import { SalaryTypeFormRule, SalaryTypeFormSchema } from "@core/form/form.rule";
import { salaryTypeFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormSalaryType from "../form-salary-type/form-salary-type";

export function SalaryType() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateSalaryType } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New SalaryType is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addSalaryType, isLoading: isCreating } =
    useQyCreateSalaryType(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<SalaryTypeFormSchema>({
    defaultValues: salaryTypeFormDefault,
    resolver: zodResolver(SalaryTypeFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: SalaryTypeFormSchema) => {
    const formData = mapCreateSalaryType(form);
    addSalaryType(formData);
  };
  const handleValidateError = (err: FieldErrors<SalaryTypeFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="SalaryType" className="salary-type">
      <HeaderContent
        title="New Salary Type"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormSalaryType />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default SalaryType;